// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"249":"9cfee5c0","453":"b883bf3c","622":"5258cda8","791":"0c83a270"}[chunkId] + ".chunk.js";
};